<template>
    <div class="rd-rule">
        <router-view></router-view>

        <div class="rd-page">
            <!-- KPI -->
            <div class="rd-kpis">
                <div class="rd-kpi" :style="{ '--c': '#4fc3ff', '--c-a': 'rgba(79,195,255,.45)', '--c-b': 'rgba(79,195,255,.22)' }">
                    <div class="rd-ring">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4fc3ff" stroke-width="2"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M7 9h10M7 13h7"/></svg>
                    </div>
                    <div class="info">
                        <div class="label">指标总数</div>
                        <div class="value">{{ kpi.total }}<small>项</small></div>
                        <div class="trend">二级 {{ kpi.level2 }} 项 · 三级 {{ kpi.level3 }} 项</div>
                    </div>
                </div>

                <div class="rd-kpi" :style="{ '--c': '#35e0b0', '--c-a': 'rgba(53,224,176,.45)', '--c-b': 'rgba(53,224,176,.22)' }">
                    <div class="rd-ring">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#35e0b0" stroke-width="2"><rect x="4" y="4" width="16" height="12" rx="2"/><path d="M8 20h8M12 16v4"/></svg>
                    </div>
                    <div class="info">
                        <div class="label">智能体绑定率</div>
                        <div class="value">{{ kpi.bindRate }}<small>%</small></div>
                        <div class="trend">{{ kpi.bound }} / {{ kpi.total }} 项已绑定 · 共 {{ kpi.agentKinds }} 个智能体</div>
                    </div>
                </div>

                <div class="rd-kpi" :style="{ '--c': '#ffd24a', '--c-a': 'rgba(255,210,74,.45)', '--c-b': 'rgba(255,210,74,.22)' }">
                    <div class="rd-ring">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ffd24a" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>
                    </div>
                    <div class="info">
                        <div class="label">评价类型</div>
                        <div class="value">{{ kpi.typeKinds }}<small>类</small></div>
                        <div class="trend">{{ kpi.topTypeText }}</div>
                    </div>
                </div>

                <div class="rd-kpi" :style="{ '--c': '#ff8a5c', '--c-a': 'rgba(255,138,92,.45)', '--c-b': 'rgba(255,138,92,.22)' }">
                    <div class="rd-ring">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ff8a5c" stroke-width="2"><path d="M4 19V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14l-8-4-8 4z"/></svg>
                    </div>
                    <div class="info">
                        <div class="label">关联评课标准</div>
                        <div class="value">{{ kpi.standard }}<small>套</small></div>
                        <div class="trend">单项满分 {{ kpi.maxScore }} 分 · 系统指标 {{ kpi.sysCount }} 项</div>
                    </div>
                </div>
            </div>

            <!-- 图表行 -->
            <div class="rd-grid">
                <div class="rd-card">
                    <div class="rd-title">评价类型构成</div>
                    <div ref="typeChart" class="rd-chart"></div>
                </div>

                <div class="rd-card">
                    <div class="rd-title">智能体覆盖分布</div>
                    <div ref="agentChart" class="rd-chart"></div>
                </div>

                <div class="rd-card">
                    <div class="rd-title">指标层级构成</div>
                    <div class="rd-level">
                        <div class="level-row">
                            <div class="head">二级指标<span class="num">{{ kpi.level2 }} 项 · {{ lv2Pct }}%</span></div>
                            <div class="level-bar"><div class="level-fill lv2" :style="{ width: lv2Pct + '%' }"></div></div>
                        </div>
                        <div class="level-row">
                            <div class="head">三级指标<span class="num">{{ kpi.level3 }} 项 · {{ lv3Pct }}%</span></div>
                            <div class="level-bar"><div class="level-fill lv3" :style="{ width: lv3Pct + '%' }"></div></div>
                        </div>
                        <div class="level-foot">
                            <span>单项满分 <b>{{ kpi.maxScore }}</b> 分</span>
                            <span>系统指标 <b>{{ kpi.sysCount }}</b> 项</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 列表 -->
            <div class="rd-card rd-table-card">
                <div class="rd-title">指标项列表<span class="more" @click="exportCsv">导出报表 ＞</span></div>

                <div class="rd-toolbar">
                    <div class="search-box">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4f77ab" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>
                        <input type="text" v-model="query.name" placeholder="请输入指标名称" @keyup.enter="doSearch" />
                    </div>
                    <select v-model="query.level" @change="doSearch">
                        <option value="">指标层级</option>
                        <option value="2">二级指标</option>
                        <option value="3">三级指标</option>
                    </select>
                    <select v-model="query.isSys" @change="doSearch">
                        <option value="">指标级别</option>
                        <option value="0">普通指标</option>
                        <option value="1">系统指标</option>
                    </select>
                    <button class="btn btn-primary" @click="doSearch">查询</button>
                    <button class="btn btn-add" @click="$router.push({ name: 'module_rule_add' })">＋ 新增指标</button>
                </div>

                <table>
                    <colgroup>
                        <col style="width:190px"><col style="width:100px"><col style="width:150px"><col style="width:170px">
                        <col style="width:90px"><col><col style="width:140px">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>名称</th><th>指标层级</th><th>评价类型</th><th>智能体</th>
                            <th>最大分数</th><th>描述</th><th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in pageRows" :key="row.id">
                            <td class="t-name" :title="row.name">{{ row.name }}</td>
                            <td>
                                <span class="tag" :class="Number(row.level) === 2 ? 'tag-l2' : 'tag-l3'">{{ Number(row.level) === 2 ? '二级指标' : '三级指标' }}</span>
                            </td>
                            <td>{{ reviewText(row.reviewType) }}</td>
                            <td>
                                <span class="agent" v-if="row.agentCode"><i></i>{{ row.agentCode }}</span>
                                <span v-else>-</span>
                            </td>
                            <td class="score">{{ row.maxScore }}</td>
                            <td class="desc" :title="row.description">{{ row.description }}</td>
                            <td class="op">
                                <router-link :to="{ name: 'module_rule_add', query: { id: row.id } }">编辑</router-link>
                                <span @click="handleClickClone(row)">克隆</span>
                                <el-popconfirm title="是否确定删除？" @confirm="handleDel(row)">
                                    <span slot="reference" class="del">删除</span>
                                </el-popconfirm>
                            </td>
                        </tr>
                        <tr v-if="!pageRows.length">
                            <td colspan="7" class="rd-empty">暂无符合条件的指标项</td>
                        </tr>
                    </tbody>
                </table>

                <div class="table-foot">
                    <span>共 {{ filteredRows.length }} 条记录 · 第 {{ page }} / {{ pageCount }} 页</span>
                    <el-pagination background layout="prev, pager, next" small
                        :total="filteredRows.length" :page-size="pageSize" :current-page.sync="page">
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 克隆弹窗（保留原功能） -->
        <el-dialog title="克隆" :visible.sync="clone.cloneConfigureShow" center :append-to-body="true" width="600px">
            <el-form ref="cloneform" :model="clone.form" label-width="80px">
                <el-form-item label="模板名称">
                    <el-input v-model="clone.form.name"></el-input>
                </el-form-item>
                <el-form-item label="院校" v-if="clone.manager">
                    <el-select style="width: 100%;" v-model="clone.deptId" filterable remote reserve-keyword
                        placeholder="请输入院校查询" :remote-method="remoteMethod" :loading="clone.cloneLoading">
                        <el-option v-for="item in clone.select" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">立即提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import { rule_lists, rule_del, clone_rule, lists as templateLists } from '@/request/api/module.js'
import { lists as college_lists } from '@/request/api/college.js'
import { get_user } from '@/request/api/user.js'

const SAMPLE_SIZE = 1000
// 评价类型配色与展示名（环形图使用）
const TYPE_META = {
    1: { label: '视频类指标', color: '#4fc3ff' },
    2: { label: '音频类指标', color: '#35e0b0' },
    3: { label: '专家评价', color: '#ffd24a' },
    4: { label: '人机协同(视频)', color: '#a78bfa' },
    5: { label: '人机协同(音频)', color: '#ff8a5c' },
}

export default {
    data() {
        return {
            allRows: [],
            kpi: {
                total: 0, level2: 0, level3: 0, bound: 0, bindRate: '0.0',
                agentKinds: 0, typeKinds: 0, topTypeText: '暂无数据',
                standard: 0, maxScore: 0, sysCount: 0,
            },
            typeDist: [],
            agentDist: [],
            query: { name: '', level: '', isSys: '' },
            applied: { name: '', level: '', isSys: '' },
            page: 1,
            pageSize: 10,
            isEdit: false,
            clone: {
                cloneConfigureShow: false,
                cloneLoading: false,
                select: [],
                deptId: '',
                manager: false,
                form: { name: '', ruleId: '' },
            },
        }
    },
    computed: {
        filteredRows() {
            const kw = (this.applied.name || '').trim().toLowerCase()
            const lv = this.applied.level
            const sys = this.applied.isSys
            return this.allRows.filter(function (r) {
                if (lv && String(r.level) !== String(lv)) return false
                if (sys) {
                    const isSys = (r.isSys === true || Number(r.isSys) === 1) ? '1' : '0'
                    if (isSys !== sys) return false
                }
                if (kw) {
                    return String(r.name || '').toLowerCase().indexOf(kw) >= 0
                }
                return true
            })
        },
        pageRows() {
            const s = (this.page - 1) * this.pageSize
            return this.filteredRows.slice(s, s + this.pageSize)
        },
        pageCount() {
            return Math.max(1, Math.ceil(this.filteredRows.length / this.pageSize))
        },
        lv2Pct() {
            const t = this.kpi.total || 0
            return t ? ((this.kpi.level2 / t) * 100).toFixed(1) : '0.0'
        },
        lv3Pct() {
            const t = this.kpi.total || 0
            return t ? ((this.kpi.level3 / t) * 100).toFixed(1) : '0.0'
        },
    },
    watch: {
        $route(val) {
            if (val.name == 'module_rule') {
                this.loadAll()
            }
        },
        filteredRows() {
            if (this.page > this.pageCount) this.page = this.pageCount
        },
    },
    created() {
        this.loadAll()
        this.loadStandard()
        this.get_role()
        this.get_college_lists('')
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
        if (this.typeChart) { this.typeChart.dispose(); this.typeChart = null }
        if (this.agentChart) { this.agentChart.dispose(); this.agentChart = null }
    },
    methods: {
        reviewText(v) {
            const list = (this.$store.state.dict && this.$store.state.dict.review_lists) || []
            const hit = list.find(function (o) { return String(o.value) === String(v) })
            return hit ? hit.label : '-'
        },
        doSearch() {
            this.applied = { name: this.query.name, level: this.query.level, isSys: this.query.isSys }
            this.page = 1
        },
        onResize() {
            clearTimeout(this._rt)
            this._rt = setTimeout(() => {
                if (this.typeChart) this.typeChart.resize()
                if (this.agentChart) this.agentChart.resize()
            }, 200)
        },
        async loadAll() {
            try {
                const res = await rule_lists({ page: 1, size: SAMPLE_SIZE })
                if (res && res.code === 0 && res.data) {
                    this.digest(res.data.list || [])
                }
            } catch (e) {
                // 后端不可达时展示 0，不打断页面
            }
        },
        async loadStandard() {
            try {
                const res = await templateLists({ page: 1, size: 1 })
                if (res && res.code === 0 && res.data) {
                    this.kpi = { ...this.kpi, standard: Number(res.data.total) || 0 }
                }
            } catch (e) {
                // 忽略
            }
        },
        digest(rows) {
            this.allRows = rows

            let level2 = 0
            let level3 = 0
            let sysCount = 0
            let bound = 0
            let maxScore = 0
            const byType = {}
            const byAgent = {}

            rows.forEach((r) => {
                const lv = Number(r.level)
                if (lv === 2) level2++
                else if (lv === 3) level3++

                if (r.isSys === true || Number(r.isSys) === 1) sysCount++

                const ms = Number(r.maxScore) || 0
                if (ms > maxScore) maxScore = ms

                if (r.agentCode) {
                    bound++
                    byAgent[r.agentCode] = (byAgent[r.agentCode] || 0) + 1
                }

                const t = Number(r.reviewType)
                if (t) byType[t] = (byType[t] || 0) + 1
            })

            const total = rows.length
            const typeKinds = Object.keys(byType).length
            const agentKinds = Object.keys(byAgent).length

            let topType = null
            Object.keys(byType).forEach((k) => {
                if (!topType || byType[k] > byType[topType]) topType = k
            })
            const topTypeText = topType
                ? (TYPE_META[topType] ? TYPE_META[topType].label : '类型' + topType) + ' ' + byType[topType] + ' 项 · 占比最高'
                : '暂无数据'

            this.kpi = {
                total: total,
                level2: level2,
                level3: level3,
                bound: bound,
                bindRate: total ? ((bound / total) * 100).toFixed(1) : '0.0',
                agentKinds: agentKinds,
                typeKinds: typeKinds,
                topTypeText: topTypeText,
                standard: this.kpi.standard,
                maxScore: maxScore,
                sysCount: sysCount,
            }

            // 评价类型构成（固定顺序 1-5）
            this.typeDist = Object.keys(TYPE_META).filter(function (k) {
                return byType[k]
            }).map(function (k) {
                return {
                    name: TYPE_META[k].label,
                    value: byType[k],
                    itemStyle: { color: TYPE_META[k].color },
                }
            })

            // 智能体覆盖（降序，去掉 AGENT_ 前缀）
            const arr = Object.keys(byAgent).map(function (k) {
                return { code: k, name: k.replace(/^AGENT_/, ''), value: byAgent[k] }
            })
            arr.sort(function (a, b) { return b.value - a.value })
            this.agentDist = arr

            this.$nextTick(() => {
                this.renderType()
                this.renderAgent()
            })
        },
        renderType() {
            const el = this.$refs.typeChart
            if (!el) return
            if (this.typeChart) this.typeChart.dispose()
            const w = el.clientWidth || 360
            const h = el.clientHeight || 200
            const cx = Math.round(w * 0.34)
            const cy = Math.round(h / 2)
            this.typeChart = echarts.init(el)
            this.typeChart.setOption({
                tooltip: { trigger: 'item', formatter: '{b}：{c} 项（{d}%）' },
                legend: {
                    orient: 'vertical',
                    right: 0,
                    top: 'middle',
                    icon: 'circle',
                    itemWidth: 10,
                    itemHeight: 10,
                    textStyle: { color: '#a9c6e8', fontSize: 11 },
                },
                graphic: [
                    { type: 'text', x: cx, y: cy - 18, style: { text: String(this.kpi.total), fill: '#ffffff', fontSize: 22, fontWeight: 500, textAlign: 'center' } },
                    { type: 'text', x: cx, y: cy + 8, style: { text: '指标总数', fill: '#7ea6d9', fontSize: 11, textAlign: 'center' } },
                ],
                series: [
                    {
                        type: 'pie',
                        radius: ['54%', '76%'],
                        center: ['34%', '50%'],
                        data: this.typeDist,
                        label: { show: false },
                        labelLine: { show: false },
                        itemStyle: { borderColor: 'rgba(7,28,66,.9)', borderWidth: 3 },
                        emphasis: { scaleSize: 6 },
                    },
                ],
            })
        },
        renderAgent() {
            const el = this.$refs.agentChart
            if (!el) return
            if (this.agentChart) this.agentChart.dispose()
            const names = this.agentDist.map(function (x) { return x.name })
            const values = this.agentDist.map(function (x) { return x.value })
            this.agentChart = echarts.init(el)
            this.agentChart.setOption({
                grid: { left: 8, right: 22, top: 8, bottom: 0, containLabel: true },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' },
                    formatter: function (p) { return 'AGENT_' + p[0].name + '：' + p[0].value + ' 项' },
                },
                xAxis: {
                    type: 'value',
                    minInterval: 1,
                    axisLabel: { color: '#7ea6d9', fontSize: 11 },
                    splitLine: { lineStyle: { color: 'rgba(63,156,255,.12)' } },
                },
                yAxis: {
                    type: 'category',
                    inverse: true,
                    data: names,
                    axisTick: { show: false },
                    axisLine: { lineStyle: { color: 'rgba(63,156,255,.3)' } },
                    axisLabel: { color: '#7ea6d9', fontSize: 10 },
                },
                series: [
                    {
                        type: 'bar',
                        data: values,
                        barWidth: 10,
                        itemStyle: {
                            borderRadius: [0, 3, 3, 0],
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                { offset: 0, color: '#1b62e0' },
                                { offset: 1, color: '#35e0b0' },
                            ]),
                        },
                    },
                ],
            })
        },
        exportCsv() {
            const head = ['名称', '指标层级', '评价类型', '智能体', '最大分数', '描述']
            const rows = this.filteredRows.map((r) => [
                r.name,
                Number(r.level) === 2 ? '二级指标' : '三级指标',
                this.reviewText(r.reviewType),
                r.agentCode,
                r.maxScore,
                r.description,
            ])
            const esc = function (v) { return '"' + String(v === null || v === undefined ? '' : v).replace(/"/g, '""') + '"' }
            const csv = '\ufeff' + [head].concat(rows).map(function (a) { return a.map(esc).join(',') }).join('\n')
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
            const a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = '指标项_' + new Date().toISOString().slice(0, 10).replace(/-/g, '') + '.csv'
            a.click()
            URL.revokeObjectURL(a.href)
        },
        //院校列表
        get_college_lists(query) {
            college_lists({ name: query, page: 1, size: 10000 }).then(res => {
                this.clone.select = res.data.list
            })
        },
        //select搜索院校
        remoteMethod(query) {
            this.get_college_lists(query)
        },
        //获取角色
        get_role() {
            get_user(this.$store.state.user.id).then(res => {
                res.data.roleList && res.data.roleList.forEach(item => {
                    if (item.slug == 'super_manager') {
                        this.clone.manager = true;
                        return;
                    }
                })
            })
        },
        //列表点击克隆按钮
        handleClickClone(data) {
            this.clone.cloneConfigureShow = true
            this.clone.form.ruleId = data.id
            this.clone.form.name = data.name + '_克隆'
        },
        //提交克隆
        onSubmit() {
            var data = JSON.parse(JSON.stringify(this.clone.form))
            if (this.clone.manager) {
                data['deptId'] = this.clone.deptId
            }
            clone_rule(data).then(res => {
                if (res.code != 0) return this.$notify.error({ title: '错误', message: res.msg });
                this.loadAll()
                this.$notify({ title: '成功', message: res.msg, type: 'success' });
                this.clone.cloneConfigureShow = false
            })
        },
        //删除
        handleDel(data) {
            rule_del({ id: data.id }).then(res => {
                if (res.code != 0) return this.$notify.error({ title: '错误', message: res.msg });
                this.loadAll()
                this.$notify({ title: '成功', message: res.msg, type: 'success' });
            })
        },
    },
}
</script>

<style scoped lang="less">
.rd-rule {
    .rd-page {
        margin: 0 10px 20px;
        color: #cfe6ff;
        font-size: 13px;
    }

    /* 横幅 */
    /* KPI */
    .rd-kpis {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 14px;
        margin-bottom: 16px;
    }

    .rd-kpi {
        display: flex;
        align-items: center;
        gap: 14px;
        position: relative;
        overflow: hidden;
        background: linear-gradient(180deg, rgba(16, 55, 130, 0.35), rgba(8, 25, 60, 0.35));
        border: 1px solid var(--c-a);
        border-radius: 8px;
        padding: 14px 18px;

        &::after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 3px;
            background: linear-gradient(180deg, var(--c), #0b2350);
            box-shadow: 0 0 10px var(--c);
        }

        &::before {
            content: '';
            position: absolute;
            right: -30px;
            top: -30px;
            width: 90px;
            height: 90px;
            border-radius: 50%;
            background: radial-gradient(circle, var(--c-b), transparent 70%);
        }

        .rd-ring {
            flex: none;
            width: 52px;
            height: 52px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: radial-gradient(circle, var(--c-b), rgba(8, 25, 60, 0.9));
            border: 1px solid var(--c-a);
            box-shadow: 0 0 14px var(--c-a), inset 0 0 12px var(--c-b);
        }

        .info {
            .label {
                font-size: 12px;
                color: #7ea6d9;
                margin-bottom: 4px;
            }

            .value {
                font-size: 26px;
                font-weight: 500;
                font-family: 'DIN Alternate', 'Segoe UI', sans-serif;
                background-image: linear-gradient(180deg, #ffffff, var(--c));
                -webkit-background-clip: text;
                background-clip: text;
                color: transparent;

                small {
                    font-size: 12px;
                    margin-left: 3px;
                }
            }

            .trend {
                font-size: 11px;
                margin-top: 3px;
                color: var(--c);
                opacity: 0.92;
            }
        }
    }

    /* 卡片 */
    .rd-card {
        background: linear-gradient(180deg, rgba(13, 40, 95, 0.35), rgba(5, 18, 45, 0.55));
        border: 1px solid rgba(63, 156, 255, 0.28);
        border-radius: 8px;
        padding: 14px 16px;
        box-shadow: inset 0 0 24px rgba(20, 70, 170, 0.15);
    }

    .rd-grid {
        display: grid;
        grid-template-columns: 5fr 4fr 3fr;
        gap: 14px;
        margin-bottom: 16px;
    }

    .rd-chart {
        height: 200px;
    }

    .rd-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        font-weight: 500;
        color: #dceeff;
        letter-spacing: 1px;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid transparent;
        border-image: linear-gradient(90deg, rgba(63, 156, 255, 0.8), transparent) 1;

        &::before {
            content: '';
            width: 8px;
            height: 8px;
            background: #3f9cff;
            transform: rotate(45deg);
            box-shadow: 0 0 8px #3f9cff;
        }

        .more {
            margin-left: auto;
            font-size: 12px;
            color: #5f8fd0;
            cursor: pointer;
            font-weight: 400;

            &:hover { color: #4fc3ff; }
        }
    }

    /* 层级面板 */
    .rd-level {
        display: flex;
        flex-direction: column;
        gap: 18px;
        margin-top: 8px;
    }

    .level-row {
        font-size: 12px;
        color: #a9c6e8;

        .head {
            display: flex;
            align-items: baseline;
            gap: 8px;
            margin-bottom: 7px;

            .num {
                margin-left: auto;
                font-family: Consolas, monospace;
                font-size: 15px;
                color: #6fc4ff;
                text-shadow: 0 0 8px rgba(79, 195, 255, 0.6);
            }
        }
    }

    .level-bar {
        height: 9px;
        border-radius: 5px;
        background: rgba(63, 156, 255, 0.14);
        overflow: hidden;
        position: relative;
    }

    .level-fill {
        height: 100%;
        border-radius: 5px;
        position: relative;

        &::after {
            content: '';
            position: absolute;
            right: 0;
            top: -2px;
            bottom: -2px;
            width: 3px;
            background: #bfeaff;
            border-radius: 2px;
        }
    }

    .lv2 {
        background: linear-gradient(90deg, #b8860b, #ffd24a);
        box-shadow: 0 0 8px rgba(255, 210, 74, 0.7);
    }

    .lv3 {
        background: linear-gradient(90deg, #1b62e0, #4fc3ff);
        box-shadow: 0 0 8px rgba(79, 195, 255, 0.7);
    }

    .level-foot {
        margin-top: auto;
        padding-top: 12px;
        border-top: 1px dashed rgba(63, 156, 255, 0.22);
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #7ea6d9;

        b {
            color: #6fc4ff;
            font-family: Consolas, monospace;
            font-weight: 500;
        }
    }

    /* 工具栏 */
    .rd-toolbar {
        display: flex;
        gap: 10px;
        align-items: center;
        margin-bottom: 14px;
        flex-wrap: wrap;
    }

    .search-box {
        display: flex;
        align-items: center;
        gap: 8px;
        background: rgba(13, 40, 95, 0.5);
        border: 1px solid rgba(63, 156, 255, 0.4);
        border-radius: 5px;
        padding: 0 12px;
        height: 34px;
        width: 210px;

        input {
            background: transparent;
            border: none;
            outline: none;
            color: #cfe6ff;
            font-size: 13px;
            width: 100%;
        }

        input::placeholder { color: #4f77ab; }
    }

    select {
        height: 34px;
        padding: 0 10px;
        border-radius: 5px;
        background: rgba(13, 40, 95, 0.5);
        border: 1px solid rgba(63, 156, 255, 0.4);
        color: #a9c6e8;
        font-size: 13px;
        outline: none;
        cursor: pointer;

        option { background: #0a1f45; }
    }

    .btn {
        height: 34px;
        padding: 0 16px;
        border-radius: 5px;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid rgba(63, 156, 255, 0.45);
        background: rgba(13, 40, 95, 0.5);
        color: #a9c6e8;
        transition: all 0.2s;

        &:hover { border-color: #4fc3ff; color: #4fc3ff; }
    }

    .btn-primary {
        background: linear-gradient(180deg, #2a7de8, #1b62e0);
        border: 1px solid #4fc3ff;
        color: #fff;
        box-shadow: 0 0 12px rgba(42, 125, 232, 0.6);

        &:hover { filter: brightness(1.15); color: #fff; }
    }

    .btn-add {
        margin-left: auto;
        background: linear-gradient(180deg, #22b98a, #0f8f6a);
        border: 1px solid #35e0b0;
        color: #eafff7;
        box-shadow: 0 0 12px rgba(53, 224, 176, 0.55);

        &:hover { filter: brightness(1.12); color: #fff; }
    }

    /* 表格 */
    table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
    }

    thead th {
        background: linear-gradient(180deg, rgba(30, 85, 190, 0.5), rgba(12, 38, 90, 0.5));
        color: #bfe0ff;
        font-size: 12px;
        font-weight: 500;
        padding: 12px 14px;
        text-align: left;
        letter-spacing: 1px;
        border-bottom: 1px solid rgba(79, 195, 255, 0.6);
        box-shadow: 0 2px 10px rgba(27, 98, 224, 0.25);
        white-space: nowrap;
    }

    tbody td {
        padding: 12px 14px;
        font-size: 13px;
        color: #c4dcf5;
        border-bottom: 1px solid rgba(63, 156, 255, 0.12);
        overflow: hidden;
        text-overflow: ellipsis;
    }

    tbody td.desc {
        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 12px;
        color: #93b6de;
        line-height: 1.5;
    }

    tbody tr:nth-child(even) { background: rgba(20, 60, 140, 0.12); }

    tbody tr { transition: background 0.15s; }

    tbody tr:hover { background: rgba(63, 156, 255, 0.1); }

    tbody tr:hover td:first-child { box-shadow: inset 3px 0 0 #4fc3ff; }

    .t-name {
        color: #eaf6ff;
        cursor: pointer;
        white-space: nowrap;
    }

    .t-name:hover {
        color: #4fc3ff;
        text-shadow: 0 0 8px rgba(79, 195, 255, 0.6);
    }

    .tag {
        display: inline-block;
        font-size: 12px;
        padding: 2px 10px;
        border-radius: 3px;
        white-space: nowrap;
    }

    .tag-l2 {
        color: #ffd24a;
        border: 1px solid rgba(255, 210, 74, 0.45);
        background: rgba(255, 210, 74, 0.1);
    }

    .tag-l3 {
        color: #6fc4ff;
        border: 1px solid rgba(79, 195, 255, 0.45);
        background: rgba(27, 98, 224, 0.2);
    }

    .agent {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        font-family: Consolas, monospace;
        font-size: 11px;
        color: #35e0b0;
        white-space: nowrap;

        i {
            flex: none;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: currentColor;
            box-shadow: 0 0 8px currentColor;
        }
    }

    .score {
        font-family: Consolas, monospace;
        font-size: 15px;
        color: #ffd24a;
        text-shadow: 0 0 8px rgba(255, 210, 74, 0.6);
    }

    .op {
        white-space: nowrap;
        font-size: 0;

        a,
        span {
            cursor: pointer;
            font-size: 12px;
            margin-right: 12px;
            color: #6fc4ff;
            text-decoration: none;
        }

        a:hover,
        span:hover {
            color: #4fc3ff;
            text-shadow: 0 0 8px rgba(79, 195, 255, 0.6);
        }

        .del {
            color: #ff6b6b;
            margin-right: 0;
        }

        .del:hover {
            color: #ff8a8a;
            text-shadow: 0 0 8px rgba(255, 107, 107, 0.6);
        }
    }

    .rd-empty {
        padding: 28px 0;
        text-align: center;
        color: #5f8fd0;
        font-size: 12px;
    }

    .table-foot {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 13px 0 0;
        font-size: 12px;
        color: #7ea6d9;
    }

    ::v-deep .el-pagination {
        padding: 0;

        button,
        .el-pager li {
            background: rgba(13, 40, 95, 0.5) !important;
            color: #a9c6e8 !important;
            border: 1px solid rgba(63, 156, 255, 0.4);
            border-radius: 4px;
            min-width: 28px;
            height: 28px;
            line-height: 26px;
            font-size: 12px;
            margin: 0 3px;
        }

        button:disabled { opacity: 0.4; }

        .el-pager li.active {
            background: linear-gradient(180deg, #2a7de8, #1b62e0) !important;
            border-color: #4fc3ff;
            color: #fff !important;
            box-shadow: 0 0 10px rgba(79, 195, 255, 0.6);
        }

        .el-pager li:hover:not(.active) {
            border-color: #4fc3ff;
            color: #4fc3ff !important;
        }
    }

    @media (max-width: 1500px) {
        .rd-kpis { grid-template-columns: repeat(2, minmax(0, 1fr)); }

        .rd-grid { grid-template-columns: 1fr 1fr; }
    }
}
</style>

<!-- 非scoped样式，确保tooltip样式全局生效 -->
<style lang="less">
.el-tooltip__popper {
    max-width: 300px !important;
    width: auto !important;
}

.el-tooltip__popper.is-dark {
    max-width: 300px !important;
}

.el-tooltip__popper .el-tooltip__content {
    white-space: normal !important;
    word-break: break-all !important;
    line-height: 1.4 !important;
}
</style>
